import Text from '../../../Text'
import { QA_NAME_PHOTO_POSITION } from '../RentalPortalPhotoGallery.constants'
import { RentalPortalPhotoGalleryTileOverlayActions } from '../RentalPortalPhotoGalleryTileOverlayActions'
import { RentalPortalPhotoGalleryTileOverlayFooter } from '../RentalPortalPhotoGalleryTileOverlayFooter'

import * as styles from './RentalPortalPhotoGalleryTileOverlay.module.css'

function RentalPortalPhotoGalleryTileOverlay({
  className = styles.RentalPortalPhotoGalleryTileOverlay,
  disabled,
  disabledReason,
  hasReorder,
  isCover,
  isReorderDisabled,
  position,
  reorderDisabledReason,
  onOpen,
  onRemove,
  onRetry,
  onSetCover,
}) {
  return (
    <div className={className}>
      <div className={styles.topRow}>
        {position ? (
          <Text
            className={styles.positionBadge}
            qaName={QA_NAME_PHOTO_POSITION}
          >
            {position}
          </Text>
        ) : null}
        <RentalPortalPhotoGalleryTileOverlayActions
          disabled={disabled}
          disabledReason={disabledReason}
          isCover={isCover}
          onOpen={onOpen}
          onRemove={onRemove}
          onRetry={onRetry}
          onSetCover={onSetCover}
        />
      </div>
      <RentalPortalPhotoGalleryTileOverlayFooter
        hasReorder={hasReorder}
        isCover={isCover}
        isReorderDisabled={isReorderDisabled}
        reorderDisabledReason={reorderDisabledReason}
      />
    </div>
  )
}

export default RentalPortalPhotoGalleryTileOverlay
